import script from "./icon-folder.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-folder.vue?vue&type=script&lang=ts&setup=true"

import "./icon-folder.vue?vue&type=style&index=0&id=45ed405b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45ed405b"]])

export default __exports__